import React, { memo } from 'react';
import { Flex, Loading } from 'onefaceui-react-components';

import { useSelector } from 'react-redux';
import { getResourceTo } from 'react/utils/utils';

function SelectionLoadingOverlay() {
  const photoAlbum = useSelector(
    (state) => state.photoAlbum
  ).toJS();

  if (!photoAlbum.isLoading) return null;

  return (
    <Flex dataTestId="loading-overlay" className="loading-overlay">
      <Loading isVisible message={getResourceTo('loading.message')} />
    </Flex>
  );
}

export default memo(SelectionLoadingOverlay);
